
import {isDefined} from './Util';
import {EN_KO, EN_DEV} from '../helpers/GlobalsHelper';

const initConversionTracking = function() {
	if ( EN_DEV.Debug ) {
		EN_DEV.Debug.log( 'initConversionTracking (trying)' );
	}
	if ( ! isDefined( EN_KO, 'settings.conversions.types' ) || EN_KO.settings.conversionTrackingInitialized ) {
		return;
	}

	if ( EN_DEV.Debug ) {
		EN_DEV.Debug.log( 'initConversionTracking (doing)' );
	}

	for ( var key in EN_KO.settings.conversions.types ) {
		if ( ! EN_KO.settings.conversions.types.hasOwnProperty( key ) ) continue; //eslint-disable-line no-prototype-builtins
		var subject = EN_KO.settings.conversions.types[key];

		var callback = ( function() {
			var cKey = key;
			return function( e ) {
				if ( EN_DEV.Debug ) {
					EN_DEV.Debug.log( 'track event', e );
				}
				trackConversion( cKey );
			};
		} )();

		EN_KO.elements.$body.on( subject.eventHandler, subject.selector, callback );
	}

	EN_KO.settings.conversionTrackingInitialized = true;
};

/*//conversion tracking triggers
EN_KO.elements.$body.on('click', '.trigger_conversion_locationSelectionGoal', function(e){
  EN_KO.functions.trackConversion('locationSelectionGoal');
});
EN_KO.elements.$body.on('click', '.trigger_conversion_locationSearchGoal', function(e){
  EN_KO.functions.trackConversion('locationSearchGoal');
});*/

const trackConversion = function( type ) {
	if ( typeof type !== 'string' || type == '' || ! isDefined( EN_KO, 'settings.conversions.types.' + type ) ) return false;

	var data = {};
	data.url = EN_KO.settings.conversions.types[type].url;
	data.label = EN_KO.settings.conversions.types[type].label;
	data.value = EN_KO.settings.conversions.types[type].value;

	if ( EN_DEV.Debug ) {
		EN_DEV.Debug.info( 'trackConversion', type, data );
	}

	var successAnalytics = data.url != '' ? trackGoogleAnalyticsPageView( data.url ) : true;
	var successAdwords = data.label != '' && typeof data.value !== 'undefined' ? trackAdwords( data.label, data.value ) : true;

	return successAnalytics && successAdwords;
};

const trackGoogleAnalyticsPageView = function( url ) { //url: /some-url

	const _gaq = window._gaq;

	if ( EN_DEV.Debug ) {
		EN_DEV.Debug.info( 'trackGoogleAnalyticsPageView', url );
	}

	if ( typeof _gaq === 'undefined' ) {
		return false;
	} else {
		_gaq.push( ['_trackPageview', url] );
		return true;
	}
};

const trackAdwords = function( label, value ) {
	if ( ! isDefined( EN_KO, 'settings.conversions.googleAdwordsSettings' ) ) {
		return false;
	}

	var data = {};
	data.id = EN_KO.settings.conversions.googleAdwordsSettings.id;
	data.language = EN_KO.settings.conversions.googleAdwordsSettings.language;
	data.format = EN_KO.settings.conversions.googleAdwordsSettings.format;
	data.color = EN_KO.settings.conversions.googleAdwordsSettings.color;
	data.remarketingOnly = EN_KO.settings.conversions.googleAdwordsSettings.remarketingOnly;
	data.label = label;
	data.value = value;

	window.google_conversion_id = data.id;
	window.google_conversion_language = data.language;
	window.google_conversion_format = data.format;
	window.google_conversion_color = data.color;
	window.google_remarketing_only = data.remarketingOnly;
	window.google_conversion_label = data.label;
	window.google_conversion_value = data.value;

	if ( EN_DEV.Debug ) {
		EN_DEV.Debug.info( 'trackAdwords', data );
	}

	//$.getScript('http://www.googleadservices.com/pagead/conversion.js'); //not neccessary, see image generation below

	var trackImg = new Image( 1,1 );
	trackImg.loading = 'eager';
	trackImg.src = '//www.googleadservices.com/pagead/conversion/' + data.id + '/?value=' + data.value + '&label=' + data.label + '&guid=ON&script=0';
	document.body.appendChild( trackImg );
	trackImg.style.display = 'none';

	return true;
};


export {
	initConversionTracking,
	trackConversion,
	trackGoogleAnalyticsPageView,
	trackAdwords,
};
